<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventory.operation.stock_count_entry.actual_count_entry') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t(
            'inventory.operation.stock_count_entry.actual_count_entry'
          ),
          href: '/stock-count_entrys'
        },
        {
          text: $t('edit'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="ready_fetch">
          <form class="form-horizontal">
            <div class="row mb-3">
              <div class="col-sm-12 col-lg-6 col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('inventory.operation.stock_count_entry.date') }}
                  </label>
                  <div class="col-md-7">
                    <ts-date-picker-input v-model="model.count_date" disabled></ts-date-picker-input>
                    <div class="validate" v-if="errors.has('count_date')">
                      {{ errors.first('count_date') }}
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 form-col-label control-label required">
                    {{ $t('inventory.operation.stock_count_entry.note') }}
                  </label>
                  <div class="col-md-7">
                    <textarea v-model="model.note" rows="3" class="form-control"
                      :class="{ 'is-invalid': errors.has('note') }"></textarea>
                    <div class="invalid-feedback" v-if="errors.has('note')">
                      {{ errors.first('note') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <form>
            <div class="row">
              <div class="col-md-12">
                <div id="container-table">
                  <ItemDetail v-model="model" :errors="errors" />
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12 text-right">
                <ts-button class="btn-primary mr-2" @click.prevent="update" :waiting="saving" v-if="model.details.length">
                  {{ $t('update') }}
                </ts-button>
                <ts-button class="btn-default" @click="$router.push({ name: 'stock-count-entry' })">
                  {{ $t('cancel') }}
                </ts-button>
              </div>
            </div>
          </form>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import ItemDetail from './components/item-detail.vue'

export default {
  name: 'stock-count-entry-edit',
  components: {
    ItemDetail,
  },
  data() {
    return {
      model: {
        stock_count_id: 0,
        note: '',
        count_date: moment().format('DD-MM-YYYY'),
        details: []
      },
      errors: new Errors(),
      ready_fetch: false,
      saving: false
    }
  },
  computed: {
    ...mapState('stockCountEntry', ['edit_data'])
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    ...mapActions('stockCountEntry', ['find']),
    async fetchResourceBeforeCreate() {
      this.ready_fetch = true
      await this.$store
        .dispatch('stockCountEntry/dataBeforeCreate')
        .catch(error => {

          this.$toasted.error(error.message)
        })
      await this.find(this.$route.params.id)
        .then(() => this.setEditData())
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.ready_fetch = false
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('stockCountEntry/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-count-entry' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    getSystemQty(row) {
      this.$store
        .dispatch('stockCountEntry/getSystemQty', row.product_id)
        .then(response => {
          row.system_qty = row.count_qty = parseFloat(response.balance)
        })
        .catch(error => {
          this.$toasted.info(error.message)
        })
    },
    clearInput() {
      this.model = {
        note: '',
        count_date: moment().format('DD-MM-YYYY'),
        details: []
      }
    },
    setEditData() {
      this.model.stock_count_id = this.edit_data.stock_count_id
      this.model.note = this.edit_data.note
      this.model.count_date = this.edit_data.count_date
      this.model.details = []
      this.edit_data.details.map(el => {
        this.model.details.push({
          stock_count_detail_id: el.stock_count_detail_id,
          barcode: el.barcode,
          product_id: el.product_id,
          uom_id: el.uom_id,
          system_qty: el.system_qty,
          count_qty: el.count_qty,
          different_qty: el.count_qty - el.system_qty,
          reason: el.reason
        })
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stockCountEntry/RESET_STATE')
    this.$store.commit('stockCountEntry/SET_EDIT_DATA', {})
    next()
  }
}
</script>
<style lang="css" scoped>
#container-table {
  max-height: 50vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

::-webkit-scrollbar {
  width: 3px;
  /* Remove scrollbar space */
  background: transparent;
  /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}

table td {
  vertical-align: middle;
}

.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}

.table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}

.table>tbody>tr>td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important
}

#amountValue tr>td {
  padding: 5px;
}
</style>
